import React, { useEffect, useState } from "react";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { useAxiosInstance } from "../../../services/Interceptor";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {
  getPersonalInfo,
  updatePersonalInfo,
} from "../../../services/CoachService";
import { states } from "../../../utils/PositionStateData";
import { setCoachProfile } from "../../../store/slices/coachSlice";
import { useDispatch } from "react-redux";

function PersonalInfoCoach() {
  const apiInstance = useAxiosInstance();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    university: "",
    city: "",
    state: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPersonalInfo = async () => {
      setLoading(true);
      try {
        const data = await getPersonalInfo(apiInstance);
        setFormData(data);
      } catch (error) {
        toast.error("Error fetching personal info: " + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPersonalInfo();
  }, [apiInstance]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const updatedProfile = await updatePersonalInfo(apiInstance, formData);
      toast.success("Successfully updated information!");
      dispatch(setCoachProfile(updatedProfile));
      setFormData(updatedProfile);
      setIsEditing(false);
    } catch (error) {
      toast.error("Error updating personal info: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      {loading && <LoadingSpinner />}
      <div
        className="float-right text-gray-600 border border-gray-300 px-3 py-1 rounded bg-gray-300 cursor-pointer"
        onClick={() => setIsEditing(!isEditing)}
      >
        {isEditing ? "Cancel" : "Edit"}
        <FontAwesomeIcon
          icon={faPenToSquare}
          className="h-4 text-gray-600 ml-2"
        />
      </div>
      <h2 className="text-xl mb-6 uppercase">Personal Info</h2>

      <form className="w-full" onSubmit={handleSubmit}>
        <div className="flex flex-wrap -mx-3">
          <div className="w-full px-3 pt-2">
            <label
              className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
              htmlFor="university"
            >
              Name
            </label>
            <input
              className={`appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white placeholder-gray-900 ${!isEditing ? "bg-gray-200" : ""}`}
              id="firstName"
              name="firstName"
              type="text"
              placeholder={formData.firstName}
              value={formData.firstName}
              onChange={handleChange}
              disabled={!isEditing}
            />
            <label
              className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
              htmlFor="university"
            >
              Lastname
            </label>
            <input
              className={`appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white placeholder-gray-900 ${!isEditing ? "bg-gray-200" : ""}`}
              id="lastName"
              name="lastName"
              type="text"
              placeholder={formData.lastName}
              value={formData.lastName}
              onChange={handleChange}
              disabled={!isEditing}
            />
            <label
              className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
              htmlFor="university"
            >
              University
            </label>
            <input
              className={`appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white placeholder-gray-900 ${!isEditing ? "bg-gray-200" : ""}`}
              id="university"
              name="university"
              type="text"
              placeholder={formData.university}
              value={formData.university}
              onChange={handleChange}
              disabled={!isEditing}
            />
          </div>
          <div className="w-full px-3 pt-2">
            <label
              className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
              htmlFor="city"
            >
              City
            </label>
            <input
              className={`appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white placeholder-gray-900 ${!isEditing ? "bg-gray-200" : ""}`}
              id="city"
              name="city"
              type="text"
              placeholder={formData.city}
              value={formData.city}
              onChange={handleChange}
              disabled={!isEditing}
            />
          </div>
          <div className="w-full px-3 pt-2">
            <label
              className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
              htmlFor="state"
            >
              State
            </label>
            <select
              id="state"
              name="state"
              value={formData.state}
              onChange={handleChange}
              className={`appearance-none block w-full  border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white placeholder-gray-900 ${!isEditing ? "bg-gray-300 color-gray-700" : ""} `}
              disabled={!isEditing}
            >
              <option value="" className="text-gray-400">
                Select a state
              </option>
              {states.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>
        </div>
        {isEditing && (
          <button
            type="submit"
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
          >
            Save
          </button>
        )}
      </form>
    </div>
  );
}

export default PersonalInfoCoach;
